import { render, staticRenderFns } from "./eMenu.vue?vue&type=template&id=563114b3&scoped=true"
import script from "./eMenu.vue?vue&type=script&lang=js"
export * from "./eMenu.vue?vue&type=script&lang=js"
import style0 from "./eMenu.vue?vue&type=style&index=0&id=563114b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563114b3",
  null
  
)

export default component.exports